import * as Sentry from '@sentry/react';
import { LOCAL_STORAGE_USER_KEY } from '@config/auth';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const identifySentryUser = (userKey: string) => {
  Sentry.setUser({ id: userKey, username: userKey });
};

export const initSentry = () => {
  if (!SENTRY_DSN) {
    console.warn('sentry config failed: no DSN');
    return;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.warn('sentry config skipped: not production');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    // trace 설정
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    // replay 설정
    replaysSessionSampleRate: 0, // normal case 0% 녹화
    replaysOnErrorSampleRate: 1.0, // error case 100% 녹화
    // 무시할 에러 (외부 SDK/브라우저 노이즈)
    ignoreErrors: [
      'AbortError',
      'AbortError: AbortError',
      // iOS in-app browser (인스타/카톡/네이버앱 등) native bridge 노이즈
      /window\.webkit\.messageHandlers/,
      // Android in-app browser (인스타 등) Java bridge 노이즈
      'Java object is gone',
      'Error invoking postMessage',
      /iabjs:\/\//,
      // Amplitude Session Replay IndexedDB (in-app browser가 storage 삭제 시 / 페이지 전환 중 DB 닫힘)
      'Database deleted by request of the user',
      'Attempt to get a record from database without an in-progress transaction',
      'An internal error was encountered in the Indexed Database server',
      'InvalidStateError',
      /Indexed Database/i,
      'UnknownError',
    ],
    // sentry event 전처리 (ignoreErrors로 못 잡는 케이스 처리)
    beforeSend(event, hint) {
      // 401 인증 만료는 정상 흐름 (axios interceptor가 토큰 재발급 처리)
      const status = (hint?.originalException as any)?.response?.status;
      if (status === 401) return null;
      return event;
    },
  });

  const userKey = localStorage.getItem(LOCAL_STORAGE_USER_KEY);
  if (userKey) identifySentryUser(userKey);

  console.log('[Sentry] Initialized successfully');
};

export default Sentry;
